"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colseModalHandler = exports.deleteDraftedFE = void 0;
var React = require("react");
var react_query_1 = require("react-query");
var react_router_dom_1 = require("react-router-dom");
var api_service_1 = require("../../../api/api_service");
var react_paginate_1 = require("../../../common/react_pagination/react_paginate");
var AGgrid_table_component_1 = require("../../../common/tables/AGgrid_table_component");
var appConstants_1 = require("../../../constants/appConstants");
var route_path_1 = require("../../../constants/route_path");
var table_data_1 = require("../../../constants/table_data");
var menu_constants_1 = require("../../../menuList/menu_constants");
var array_helpers_1 = require("../../../utils/array_helpers");
var fe_services_1 = require("../fe_services");
('../../../constants/appConstants');
var userId = null;
var deleteDraftedFE = function (id) {
    userId = id;
};
exports.deleteDraftedFE = deleteDraftedFE;
var colseModalHandler = function () {
    userId = null;
};
exports.colseModalHandler = colseModalHandler;
var FEDraftedList = function (_a) {
    var searchValue = _a.searchValue, selectedCities = _a.selectedCities, CurrentPagelimit = _a.CurrentPagelimit, isFilterButton = _a.isFilterButton;
    var _b = React.useState(undefined), feDraftedLis = _b[0], setFeDraftedList = _b[1];
    var _c = React.useState(0), totalCount = _c[0], setTotalCount = _c[1];
    var FeDraftedfeatures = (0, array_helpers_1.getAccessibleFeatures)(menu_constants_1.FEATURE_CONSTANTS.feManagement);
    console.log('FeDraftedfeatures:', FeDraftedfeatures);
    var _d = React.useState(), errorMessage = _d[0], setErrorMessage = _d[1];
    var UpdateListData = React.useContext(appConstants_1.ReloadListContext);
    var _e = React.useState(1), pageCount = _e[0], setpageCount = _e[1];
    var _f = React.useState(0), totalPageCount = _f[0], setTotalPageCount = _f[1];
    var feManagementFeatures = (0, array_helpers_1.getAccessibleFeatures)(menu_constants_1.FEATURE_CONSTANTS.feManagement);
    var nav = (0, react_router_dom_1.useNavigate)();
    var onRowClickedHandler = function (e) {
        var selectedDraftedUserId = e.data.id;
        if (userId == selectedDraftedUserId) {
            e.stopPropagation();
        }
        else {
            nav("/".concat(route_path_1.default.PATHS.fe, "/").concat(route_path_1.default.PATHS.editFE, "/").concat(selectedDraftedUserId), { replace: true });
        }
    };
    var fetchDraftFE = function (endPoint, payLoad, domain) {
        (0, fe_services_1.fetchFEList)(endPoint, payLoad, domain)
            .then(function (response) {
            setErrorMessage("");
            var pageSize = CurrentPagelimit
                ? parseInt(CurrentPagelimit.value.toString())
                : 50;
            var count = Math.ceil(response.count / pageSize);
            setTotalPageCount(count);
            setFeDraftedList(response.result);
            setTotalCount(response.count);
        })
            .catch(function (err) {
            setErrorMessage(err);
            setFeDraftedList([]);
        });
    };
    var refetch = (0, react_query_1.useQuery)(['draft-fe', pageCount], function () {
        var currentPage = pageCount < 1 ? 1 : pageCount;
        var payload = (0, array_helpers_1.createPayloadForFEList)(appConstants_1.FE_USER_TYPES.drafted, searchValue, selectedCities);
        payload.page = currentPage;
        payload.size = CurrentPagelimit
            ? parseInt(CurrentPagelimit.value.toString())
            : 50;
        fetchDraftFE(api_service_1.api_service.api_urls.FE_LIST, payload, process.env.VENDOR_BASE_URL);
        if (UpdateListData.isListReloaded) {
            UpdateListData.setIsListReloaded(false);
        }
    }).refetch;
    React.useEffect(function () {
        if (pageCount != 1) {
            setpageCount(1);
        }
        else {
            refetch();
        }
    }, [isFilterButton]);
    var handlePageClick = function (data) {
        var currentPage = data.selected + 1;
        setpageCount(currentPage);
    };
    return (React.createElement("div", { className: "custom-pagination-table ".concat(!feManagementFeatures[menu_constants_1.FEATURE_CONSTANTS.editFE] && 'unclickablerow') },
        React.createElement(AGgrid_table_component_1.default, { isSortable: true, columnDefs: table_data_1.default.FE_DRAFTED_COLUMNS, rows: feDraftedLis && feDraftedLis, onRowClicked: feManagementFeatures[menu_constants_1.FEATURE_CONSTANTS.editFE] && onRowClickedHandler, errorMessage: errorMessage, pagination: false }),
        React.createElement(react_paginate_1.default, { onPageChange: handlePageClick, pageCount: totalPageCount, currentPage: pageCount, total: totalCount, dataLength: feDraftedLis === null || feDraftedLis === void 0 ? void 0 : feDraftedLis.length, currentPageLimits: CurrentPagelimit === null || CurrentPagelimit === void 0 ? void 0 : CurrentPagelimit.value })));
};
exports.default = FEDraftedList;
